var a = {
  "is-base32": "Value must have a valid Base32 format",
  "is-email": "'{{- value}}' is not a valid email address",
  "is-fqdn": "{{name}} must be a valid FQDN. (e.g. docs.yourcompany.com)",
  "is-fqdn-or-ip": "Enter a valid DNS name or IP address",
  "is-http-url": "'{{- value}}' is not a valid url",
  "is-https-url": "'{{- value}}' is not a secure url (HTTPS is required)",
  "is-ip-range": "'{{- value}}' is not a valid IP range",
  "is-numeric": "{{name}} must be a number",
  "is-required": "{{name}} cannot be empty",
  "is-url": "'{{- value}}' is not a valid url",
  max: "Value must be less than or equal to {{0}}",
  "max-length": "Maximum input size for this field is {{0}} characters",
  min: "Value must be greater than or equal to {{0}}",
  "min-length": "{{name}} is too short (minimum is {{0}} characters)"
};
export { a as default };